import { Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'retroalimentacion-mi-evaluacion',
  standalone: false,
  templateUrl: 'retroalimentacion-mi-evaluacion.component.html',
  styleUrls: ['../retroalimentacion.component.scss']
})

export class RetroalimentacionMiEvaluacionComponent implements OnInit {
  meta;

  constructor(public dialogRef: MatDialogRef<RetroalimentacionMiEvaluacionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.meta = this.data.meta;
  }

  cerrar() {
    this.dialogRef.close();
  }
}
